<template>
    <div class="chart-container">
        <div class="chart-header">
            <h3>{{ title }}</h3>
            <OperationsInsightsMenu
                :disabled="isLoading || !!error"
                @export-c-s-v="exportToCSV"
            />
        </div>
        <div v-if="isLoading">
            Loading...
        </div>
        <div
            v-if="error"
            class="error"
        >
            {{ error }}
        </div>
        <HighChart
            ref="chartRef"
            :options="enhancedChartOptions"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import HighChart from '@agyletime/vue-3-common/src/components/Chart/BoostedHighChart.vue';
import OperationsInsightsMenu from './OperationsInsightsMenu.vue';
import { Chart, Options } from 'highcharts';

interface Props {
    title: string;
    chartOptions: Partial<Options>;
    isLoading: boolean;
    error: string | null;
}

const props = defineProps<Props>();

const chartRef = ref();

const enhancedChartOptions = computed(
    () =>
        ({
            ...props.chartOptions,
            exporting: { enabled: false }
        }) as Partial<Chart>
);

const exportToCSV = () => {
    const chart = chartRef.value?.chart();
    if (chart) {
        const csv = chart.getCSV();
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${props.title.replace(/\s+/g, '_')}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }
};
</script>

<style scoped lang="scss">
.error {
    color: red;
    font-size: 14px;
    margin: 10px 0;
}

.chart-container {
    height: 400px;
    width: 48%;
    margin-bottom: 2rem;
    margin: auto;
}

.chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}
</style>